/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Key_MissingInputs */

const en_ai_key_missing = /** @type {(inputs: Ai_Key_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not set`)
};

const de_ai_key_missing = /** @type {(inputs: Ai_Key_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht gesetzt`)
};

/**
* | output |
* | --- |
* | "Not set" |
*
* @param {Ai_Key_MissingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_key_missing = /** @type {((inputs?: Ai_Key_MissingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Key_MissingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_key_missing(inputs)
	return en_ai_key_missing(inputs)
});